import {
  getSecureLocalItem,
  removeSecureLocalItem,
  setSecureLocalItem,
} from "@/lib/secureLocalStorage";

const setLocalUserInfo = (userInfo: unknown) => {
  setSecureLocalItem("userInfo", JSON.stringify(userInfo));
};

const getUserInfo = () => {
  const userInfo = getSecureLocalItem("userInfo");
  return userInfo ? JSON.parse(userInfo) : null;
};

const setLocalTheme = (theme: string) => {
  localStorage.setItem("theme", theme);
};

const getTheme = () => {
  const theme = localStorage.getItem("theme");
  return theme ?? "light";
};

const setLocalLanguage = (language: string) => {
  localStorage.setItem("language", language);
};

const getLanguage = () => {
  const language = localStorage.getItem("language");
  return language ?? "en";
};

const setLocalTenantId = (tenantId: string) => {
  setSecureLocalItem("tenantId", tenantId);
};

const getTenantId = () => {
  const tenantId = getSecureLocalItem("tenantId");
  return tenantId ?? null;
};

const setLocalAccessToken = (accessToken: string) => {
  setSecureLocalItem("accessToken", accessToken);
};

const getAccessToken = () => {
  const accessToken = getSecureLocalItem("accessToken");
  return accessToken ?? null;
};

const setLocalRefreshToken = (refreshToken: string) => {
  setSecureLocalItem("refreshToken", refreshToken);
};

const getRefreshToken = () => {
  const refreshToken = getSecureLocalItem("refreshToken");
  return refreshToken ?? null;
};

const clearLocalStorage = () => {
  localStorage.clear();
};

export {
  clearLocalStorage,
  getAccessToken,
  getLanguage,
  getRefreshToken,
  getTenantId,
  getTheme,
  getUserInfo,
  setLocalAccessToken,
  setLocalLanguage,
  setLocalRefreshToken,
  setLocalTenantId,
  setLocalTheme,
  setLocalUserInfo,
};
